import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import accessory20 from "../../Assets/accessory20.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav } from "react-bootstrap";
import "../../App.css";

const Greenhouse_Clamp_Set_Wire_Hook_Tensioner_Set = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 66,
      name: "Greenhouse Clamp Set (Wire, Hook & Tensioner Set)",
      price: 250,
      image: accessory20,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <img
            src={accessory20}
            alt="Poly House Gutter Plate"
            className="d-block w-100"
          />
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Greenhouse Clamp Set (Wire, Hook & Tensioner Set)
            </h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>
            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  The Greenhouse Clamp Set consists of multiple components used
                  for tensioning and securing greenhouse plastic films, nets, or
                  shade covers. This set typically includes a wire tensioner,
                  hook, and clip that work together to hold materials firmly in
                  place.
                </p>
                <i>Note: Minimum Order Quantity: 1000 Units.</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <p>
                  <ul>
                    <li>
                      <span className="fw-bold">Material:</span>Plastic and
                      Metal (Galvanized) components
                    </li>
                    <li>
                      <span className="fw-bold">Type:</span> Wire tensioner and
                      hook set
                    </li>
                    <li>
                      <span className="fw-bold">Functionality:</span> Designed
                      to fasten nets and plastic sheets
                    </li>
                    <li>
                      <span className="fw-bold">Size:</span> Customizable for
                      various tensioning requirements
                    </li>
                    <li>
                      <span className="fw-bold">Usage/Applications:</span>{" "}
                      Secure materials like plastic film, shade nets, and
                      greenhouse covers.
                    </li>

                    <li>
                      <span className="fw-bold">Brand:</span> RGCPL
                    </li>
                    <li>
                      <span className="fw-bold">Durability:</span> 2-3 Years
                    </li>
                    <li>
                      <span className="fw-bold">Minimum Order Quantity:</span>{" "}
                      500 pieces
                    </li>
                  </ul>
                </p>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Flexible Design: Adjustable components for varied
                    applications.
                  </li>
                  <li>
                    Corrosion-resistant: Galvanized metal parts for longer life.
                  </li>
                  <li>
                    Durable: Strong plastic clips ensure secure fastening.
                  </li>
                  <li>
                    Easy Installation: Quick to install and adjust tension.
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <p>
                  <ul>
                    <li>
                      <span className="fw-bold">Item Code:</span> RGCPL-0020
                    </li>
                    <li>
                      <span className="fw-bold">Delivery Time:</span> 7-8 Days
                    </li>
                    <li>
                      <span className="fw-bold">Port of Dispatch:</span>{" "}
                      Maharashtra, India
                    </li>
                    <li>
                      <span className="fw-bold">Production Capacity:</span> 1000
                      Pieces Per Day
                    </li>
                    <li>
                      <span className="fw-bold">Packaging Details:</span> Large
                      Bags
                    </li>
                    <li>
                      <span className="fw-bold">Payment Terms:</span> Advance
                      Payment
                    </li>
                    <li>
                      <span className="fw-bold">Payment Mode:</span> RTGS / NEFT
                      / IMPS
                    </li>
                  </ul>
                </p>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">
          Importance of Greenhouse Clamp Set (Wire, Hook & Tensioner Set):
        </h5>
        <p className="text-justify">
          <ul>
            <li>
              <span className="fw-bold">Maintains Tension:</span> Ensures that
              the greenhouse film or net remains taut, preventing it from
              flapping or tearing due to strong winds or mechanical stress.
            </li>
            <li>
              <span className="fw-bold">Secures the covering:</span> This
              accessory helps in securing the covering material, ensuring
              longevity and preventing damage to crops.
            </li>
            <li>
              <span className="fw-bold">Weather resistance:</span> Protects the
              integrity of the greenhouse by holding coverings firmly in place
              during harsh weather.
            </li>
          </ul>{" "}
        </p>
        <h5 className="mt-3">
          Key Benefits of Greenhouse Clamp Set (Wire, Hook & Tensioner Set):
        </h5>

        <p className="text-justify">
          <ul>
            <li>
              Helps maintain tension in shade nets, greenhouse films, and
              polythene covers.
            </li>
            <li>Ensures secure fastening and prevents sagging.</li>
            <li>Provides stability and protection against strong winds.</li>
          </ul>
        </p>
        <h5 className="mt-3">
          Applications of Greenhouse Clamp Set (Wire, Hook & Tensioner Set):
        </h5>
        <p className="text-justify">
          <ul>
            <li>
              Used to secure materials like plastic film, shade nets, and
              greenhouse covers.
            </li>
            <li>
              Suitable for all greenhouse types, including tunnels, low tunnels,
              and high tunnels.
            </li>
          </ul>
        </p>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Greenhouse_Clamp_Set_Wire_Hook_Tensioner_Set;
